var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loadState === undefined ? _c("div", [_vm._m(0)]) : _vm._e(),
      _vm._v(" "),
      _vm.loadState === "maintenance"
        ? _c("flow-error", {
            attrs: {
              name: "Stop Service",
              state: "maintenance",
              phonetext: "To stop service by phone call us at",
              closepath: "/stop-service"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loadState === "error"
        ? _c("flow-error", {
            attrs: {
              name: "Stop Service",
              state: "error",
              phonetext: "To stop service by phone call us at",
              closepath: "/stop-service"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loadState === "complete" ? _c("router-view") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bill-pay__page-loader" }, [
      _c("img", {
        staticClass: "bill-pay__page-loader--svg",
        attrs: {
          src:
            "/wp-content/themes/gmptwentynineteen/assets/images/loader-grey.svg"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }